<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="../">
                        {{t('home')}}
                    </router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link :to="`${subLink}`">
                        {{t(subTitle)}}
                    </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                    {{t(title)}}
                </li>
            </ol>
        </nav>
    </div>
</template>
<script>

import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default {
    name: 'BreadCrumb',
    props:{
        title: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        subLink: {
            type: String,
            default: ''
        },
    },
    setup(props) {
        const { t } = useI18nUtils()

        return {
        // i18n
        t,
        }
    }
}
</script>